module.exports = __webpack_public_path__ + "img/Alt_fill_lines.f84bb2f3.png";